import React from 'react';
import RobotsAddEdit from './robots-add-edit';
import RobotsAddEditModal from './robots-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { ROBOTS_ADD_EDIT } = MODAL_TYPES;

const RobotsModals = () => {
  return (
    <>
      <RobotsAddEdit modalId={ROBOTS_ADD_EDIT} />
      <RobotsAddEditModal />
    </>
  );
};

export default RobotsModals;
